const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function track(type, meta = {}) {
  try {
    const consent = JSON.parse(localStorage.getItem("fx_consent") || "null");
    if (!consent || !consent.analytics) return;
    fetch(`${API}/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ type, meta }),
    }).catch(() => {});
  } catch {}
}
